import { render, staticRenderFns } from "./ListSkills.vue?vue&type=template&id=b6dd2388&"
import script from "./ListSkills.vue?vue&type=script&lang=js&"
export * from "./ListSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports